import getConfig from 'next/config';

import type { NextConfig } from 'src/types/nextConfig';

/**
 * Read per call rather than destructured on import: module-scope destructuring of
 * `publicRuntimeConfig` throws without a Next runtime, which took down every Storybook
 * story reaching this file (the reviews drawer does, via FeefoAttribution's logo).
 * `getConfig()` is a plain getter, so calling it per invocation costs nothing.
 */
const staticAssetsCDN = () =>
  (getConfig() as NextConfig | undefined)?.publicRuntimeConfig?.STATIC_ASSETS_CDN ?? '';

export const getIconPath = (svg: string) => `${staticAssetsCDN()}/svgs/${svg}`;

export const getImagePath = (image: string) => `${staticAssetsCDN()}/images/${image}`;
